import CertificatesForm from '@/components/public/services/certificates/CertificatesForm';
import ServiceRequestLayout from '@/components/public/services/ServiceRequestLayout';

export default function Certificates() {
  return (
    <ServiceRequestLayout
      seoTitle="Atestados e Declarações"
      seoDescription="Solicite atestados e declarações emitidos pela Junta de Freguesia para os mais diversos fins legais e administrativos."
      badge="Serviços ao Cidadão"
      breadcrumbs={[{ label: 'Serviços', href: '/services' }, { label: 'Atestados e Declarações' }]}
      title="Atestados."
      accentWord="Atestados."
      subtitle="Solicite atestados e declarações emitidos pela Junta de Freguesia para os mais diversos fins legais e administrativos."
      panelTitle="Pedido de Atestado"
      panelIntro="Selecione o tipo de atestado pretendido e preencha os seus dados. Os serviços entrarão em contacto quando o documento estiver disponível."
    >
      <CertificatesForm />
    </ServiceRequestLayout>
  );
}
